/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DPL CMS - REST API
 * The REST API provided by the core REST module.
 * OpenAPI spec version: Versioning not supported
 */

/**
 * If/how the instance should be repeated in the future: <br/> - single: The instance should not be repeated <br/> - weekly: The instance should be repeated weekly from the first day of the repetition until the provided end date. The week day of the first instance defines which weekday should be used for the repeated instances.
 */
export type DplOpeningHoursListGET200ItemRepetitionType =
  (typeof DplOpeningHoursListGET200ItemRepetitionType)[keyof typeof DplOpeningHoursListGET200ItemRepetitionType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DplOpeningHoursListGET200ItemRepetitionType = {
  none: "none",
  weekly: "weekly"
} as const;
